import React from 'react';
import ReactDOM from 'react-dom';

import { Hydrate, QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
const reactappElement = rootElement.querySelector('reactapp');
if (rootElement.children?.length > 0 && !reactappElement) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Hydrate state={window.__REACT_QUERY_STATE__}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Hydrate>
      </QueryClientProvider>
    </React.StrictMode>,
    rootElement
  );

} else {
  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
    rootElement
  );

}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
